import { render, staticRenderFns } from "./CadastroConfiguracaoVenda.vue?vue&type=template&id=123009be"
import script from "./CadastroConfiguracaoVenda.vue?vue&type=script&lang=js"
export * from "./CadastroConfiguracaoVenda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports